module.exports = __webpack_public_path__ + "static/media/desktop-picture-retina-small.3aa34516.jpeg";